<script>
import { mapGetters } from 'vuex';
import Panels from './Panels.vue';
import ButtonDefault from '../Buttons/ButtonDefault.vue';

export default {
  name: 'GearChangesTabs',
  components: {
    Panels,
    ButtonDefault,
  },
  data: () => ({
    activeTabIndex: null,
  }),
  computed: {
    ...mapGetters({
      meetings: 'GearChangesTabs/getData',
    }),
    outputedMeetings() {
      const { activeTabIndex, meetings } = this;
      return activeTabIndex === null ? meetings : [meetings[activeTabIndex]];
    },
    tabs() {
      return this.meetings ? this.meetings.map(m => m.meetingName) : [];
    },
  },
  mounted() {
    this.$store.dispatch('GearChangesTabs/fetchGearChangesData');
  },
  methods: {
    updateActiveTabIndex(index) {
      const activeTabIndex = this.activeTabIndex;
      this.activeTabIndex = activeTabIndex === index ? null : index;
    },
  },
};
</script>

<template>
  <div class="gear-changes-tabs">
    <h3 class="gear-changes-tabs__title">today</h3>
    <ul class="gear-changes-tabs__tabs" role="tablist">
      <li v-for="(tab, index) in tabs"
          :key="`gear-changes-tab-${index}`"
          class="gear-changes-tabs__tab"
      >
        <a class="gear-changes-tabs__tab-button"
           href="#"
           @click.prevent="updateActiveTabIndex(index)"
        >
          <ButtonDefault :button-text="tab"
                         :is-active="index === activeTabIndex"
          />
        </a>
      </li>
    </ul>
    <div class="gear-changes-tabs__panels">
      <div v-for="(meetings, index) in outputedMeetings"
           :key="`panel-${index}`"
      >
        <Panels :meeting-name="meetings.meetingName"
                :racing-events="meetings.racingEvents"
        />
      </div>
    </div>
  </div>
</template>
